export default {
    chinese: /[\u4e00-\u9fa5]$/,
    email: /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/,
    mobilePhone: /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/,
    phoneNumber400: /^400-[0-9]*$/,
    // phoneNumber400: /^400(-)?[0-9]*$/,
    phoneNumber: /^((0\d{2,3})-)(\d{7,8})$/,
    url: /^https?:\/\/(([a-zA-Z0-9_-])+(\.)?)*(:\d+)?(\/((\.)?(\?)?=?&?[a-zA-Z0-9_-](\?)?)*)*$/i,
    loginID: /^[0-9a-zA-Z_]{6,30}$/,
    password: /^[0-9a-zA-Z_]{6,20}$/,
    ID: /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)?$/i,
    BankCardID: /^([1-9]{1})(\d{14,18})$/,
    IP: /^((25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d)))\.){3}(25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d)))$/
}
